import { forwardRef } from "react";
import type { ButtonHTMLAttributes } from "react";
import { cn } from "@/utils/cn";

type ButtonVariant = "default" | "primary" | "ghost" | "accent-outline";
type ButtonSize = "default" | "sm" | "xs";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant;
  size?: ButtonSize;
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = "default", size = "default", className, ...rest }, ref) => {
    const classes = cn(
      "btn",
      variant === "primary" && "primary",
      variant === "ghost" && "ghost",
      variant === "accent-outline" && "accent-outline",
      size === "sm" && "sm",
      size === "xs" && "xs",
      className
    );
    return <button ref={ref} className={classes} {...rest} />;
  }
);
Button.displayName = "Button";
